var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.738 18.965-6.612 4.947a.44.44 0 0 1-.631-.111.494.494 0 0 1-.063-.418l2.44-8.128a.49.49 0 0 0-.163-.524L.183 9.661a.49.49 0 0 1-.094-.664.445.445 0 0 1 .36-.192l8.119-.077a.456.456 0 0 0 .425-.324l2.578-8.08a.449.449 0 0 1 .573-.3c.134.048.24.159.285.3l2.578 8.08a.456.456 0 0 0 .425.324l8.12.077c.25.002.45.216.448.479a.486.486 0 0 1-.183.377l-6.526 5.07a.488.488 0 0 0-.162.524l2.44 8.128a.48.48 0 0 1-.296.595.436.436 0 0 1-.399-.066l-6.611-4.947a.437.437 0 0 0-.525 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.f175cabe90cc24b54764bd83fae8270a.svg";
export { ForwardRef as ReactComponent };